<template>
  <div>
    <div @click="close()" class="fixed inset-0 z-50 bg-gray-900 bg-opacity-70 w-screen h-screen"></div>

    <div
      id="cashbackResultModalContainer"
      class="fixed flex flex-col items-center top-0 z-50 overflow-x-hidden overflow-y-auto lg:overflow-hidden lg:justify-center h-full w-full lg:inset-0"
    >
      <div class="w-full max-w-[97%] text-right lg:hidden">
        <button @click="close()" class="bg-white rounded-full h-10 w-10 appearance-none flex-shrink-0 mt-2 p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
      </div>

      <div
        v-closable="{ handler: 'close', isOpen: true }"
        class="bg-white rounded-xl py-10 px-14 lg:px-[80px] w-full max-w-[97%] lg:w-[424px] lg:max-w-[424px] mt-4 mb-20 lg:mt-0 lg:mb-0 m-auto relative"
      >
        <button @click="close()" class="hidden lg:block bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
        <div class="text-center">
          <img :src="resultIcon" :alt="message" class="mx-auto mb-9 lg:mb-8 w-[75px] h-[75px]" />
          <p class="font-body font-semibold text-base text-gray-900">{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success',
    },
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    resultIcon() {
      if (this.type === 'success') return require('@/assets/img/cashback/successful.svg')
      if (this.type === 'unavailable') return require('@/assets/img/cashback/unavailable.svg')
      return require('@/assets/img/cashback/rejection.svg')
    },
  },
  mounted() {
    document.querySelector('body').classList.add('overflow-hidden')
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-hidden')
  },
  methods: {
    close() {
      document.querySelector('body').classList.remove('overflow-hidden')
      this.$emit('close')
    },
  },
}
</script>
